import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { URL } from '../../../constant';

import { useAsideState } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';

function Header () {
  const history = useHistory();
  const { t } = useTranslation();
  const { setAsideState } = useAsideState();
  const { setAmplitudeLog } = useAmplitude();

  const handleMenuOpen = useCallback(() => {
    // let tab = "home";
    setAsideState({ menu: true }); 
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '메인메뉴 조회' });
  }, []);

  return (
    <div className="header_top gb bg_sky">
      <div className="inner">
        <div className="btns_wrap">
          <div className="center_wrap cls">
            <div className="tit_area">
              <button
                className="btn_exit"
                type="button"
                onClick={() => history.replace(`${URL.SELECT_LEARNING}`)}
              >
                <img src="/static/images/icon/btn_back.svg" alt="" />
              </button>
              <button className="tit_btn" type="button">
                {t('LC_03_05_01.msg001')}
              </button>
            </div>
            <div className="right_area">
              <div className="menu_btn">
                {/* <button type="button" onClick={handleOcr}>
                  <img src="/static/images/icon/btn_ocr_th.svg" alt="" />
                </button> */}
                <button type="button" onClick={handleMenuOpen}>
                  <img src="/static/images/icon/btn_menu_th.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;